import { store } from 'redux/store';
import { useCallback, useEffect, useState } from 'react';
import { format } from 'date-fns';

import { getLastOperation } from '../api/getLastOperation';

const defaultDate = '1990-01-01T00:00';

export const useGetLastOperationDate = (societyId: string) => {
  const [lastOperationDate, setLastOperationDate] = useState<string>('');
  const [formattedLastOperationDate, setFormattedLastOperationDate] =
    useState<string>('');

  const fetchLastOperationDate = useCallback(async () => {
    if (!societyId) return;

    try {
      const lastOperation = await store.dispatch(
        getLastOperation({ societyId })
      );

      const lastOperationDate = lastOperation?.date || defaultDate;

      setLastOperationDate(lastOperationDate);
      const formattedResponse = format(
        new Date(lastOperationDate),
        'yyyy-MM-dd'
      );
      setFormattedLastOperationDate(formattedResponse);
    } catch (error) {
      setLastOperationDate(defaultDate);
    }
  }, [societyId]);

  useEffect(() => {
    fetchLastOperationDate();
  }, [fetchLastOperationDate]);

  return {
    data: {
      lastOperationDate,
      formattedLastOperationDate,
    },
  };
};
